// Get images
// https://www.flickr.com/photos/195241587@N06/with/51944722029/

const ProjectsGallery = [
    {
        id: 1,
        imageSrc: "https://live.staticflickr.com/65535/52191411398_028eb10e3f_b.jpg",
        caption: "About Me",
        desc: "This is a mini project based on html5. Just to start!",
        githubLink: "https://github.com/abduldaim-ad/html_web_page",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 2,
        imageSrc: "https://live.staticflickr.com/65535/52191393316_29df75d4af_b.jpg",
        caption: "Resume",
        desc: "This is also a mini project based on html5 for practice of advanced html5 elements.",
        githubLink: "https://github.com/abduldaim-ad/HTML",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 3,
        imageSrc: "https://live.staticflickr.com/65535/52190379932_a37d7681d2_b.jpg",
        caption: "Website Layout",
        desc: "This project is based on understanding the layout of websites.",
        githubLink: "https://github.com/abduldaim-ad/html-css_practice_website",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 4,
        imageSrc: "https://live.staticflickr.com/65535/52190381077_716e568a53_b.jpg",
        caption: "Search Bar Frontend",
        desc: "Just a frontend with a search bar and a table with dummy data.",
        githubLink: "https://github.com/abduldaim-ad/Search_Bar_Filter_Table",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 5,
        imageSrc: "https://live.staticflickr.com/65535/52190381757_d7a4feba79_b.jpg",
        caption: "Navbar JSX Practice",
        desc: "To design a simple navbar to practice JS XML.",
        githubLink: "https://github.com/abduldaim-ad/ReactJS_Practice",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 6,
        imageSrc: "https://live.staticflickr.com/65535/52190382102_a82da4c4af_b.jpg",
        caption: "E-Bell C2C Webpage",
        desc: "Simple design of E-commerce web page with a navbar and gradient look.",
        githubLink: "https://github.com/abduldaim-ad/E-Bell_C2C_Website_Practice",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 7,
        imageSrc: "https://live.staticflickr.com/65535/52191391726_e92632f2b2_b.jpg",
        caption: "Ultimate Frisbee Website",
        desc: "This project is for the practice of CSS. A website with some styled text/table/image.",
        githubLink: "https://github.com/abduldaim-ad/html_css_practice",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 8,
        imageSrc: "https://live.staticflickr.com/65535/52191392371_5374d7405e_b.jpg",
        caption: "Portfolio HTML/CSS",
        desc: "Simple one page portfolio to practice html/css.",
        githubLink: "https://github.com/abduldaim-ad/Porfolio-Website",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 9,
        imageSrc: "https://live.staticflickr.com/65535/52190381887_39f0b26708_b.jpg",
        caption: "Website Boostrap Practice",
        desc: "This simple website was developed to practice the basics of bootstrap.",
        githubLink: "https://github.com/abduldaim-ad/quiz_app_practice",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 10,
        imageSrc: "https://live.staticflickr.com/65535/52190382207_4f11b80ccb_b.jpg",
        caption: "Quiz App",
        desc: "Simple quiz app which has four questions with a submit button.",
        githubLink: "https://github.com/abduldaim-ad/QuizJS",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 11,
        imageSrc: "https://live.staticflickr.com/65535/52191411003_04a1535707_b.jpg",
        caption: "Portfolio Bootstrap",
        desc: "This portfolio is deployed and developed using html/css/bootstrap.",
        githubLink: "https://github.com/abduldaim-ad/portfolio-ad",
        status: "Deployed Link Here",
        deployedLink: "https://abduldaim-ad.github.io/portfolio-ad/",
        pointerEvents: "",
    },
    {
        id: 12,
        imageSrc: "https://live.staticflickr.com/65535/52191651784_5e854d25d5_b.jpg",
        caption: "Form Auto Complete JS",
        desc: "On clicking the checkbox, the data of previous fields is copied to the next fields.",
        githubLink: "https://github.com/abduldaim-ad/form",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 13,
        imageSrc: "https://live.staticflickr.com/65535/52191394596_7a227b5538_b.jpg",
        caption: "Hover to Display JS",
        desc: "On hovering over small image, that particular image is displayed in large div.",
        githubLink: "https://github.com/abduldaim-ad/gallery",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 14,
        imageSrc: "https://live.staticflickr.com/65535/52191408768_af8cb280db_b.jpg",
        caption: "Simple Calculator",
        desc: "This is very simple calculator to practice the basics of React.js.",
        githubLink: "https://github.com/abduldaim-ad/simple_calculator_react",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 15,
        imageSrc: "https://live.staticflickr.com/65535/52191391856_836a3b2ff5_b.jpg",
        caption: "Top Three",
        desc: "This website displays the top three programming languages (dummy data).",
        githubLink: "https://github.com/abduldaim-ad/top_three_react_app",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 16,
        imageSrc: "https://live.staticflickr.com/65535/52190383507_bfa6fc907b_b.jpg",
        caption: "Greeting Website",
        desc: "Good Morning, Good Afternoon and Good Night based on current time.",
        githubLink: "https://github.com/abduldaim-ad/greeting_website_reactjs",
        status: "Deployed Link Here",
        deployedLink: "https://abduldaim-ad.github.io/greeting_website_reactjs",
        pointerEvents: "",
    },
    {
        id: 17,
        imageSrc: "https://live.staticflickr.com/65535/52191392921_3f0dbcb8a5_b.jpg",
        caption: "Navbar React Router",
        desc: "This mini-project is to practice how React.js uses the concept of virtual-DOM.",
        githubLink: "https://github.com/abduldaim-ad/navbar",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 18,
        imageSrc: "https://live.staticflickr.com/65535/52191648789_462d8caaef_b.jpg",
        caption: "ToDo List React.js",
        desc: "We can add to or remove items from the list. The items are inserted in a sorted manner.",
        githubLink: "https://github.com/abduldaim-ad/todo_list_reactjs",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 19,
        imageSrc: "https://live.staticflickr.com/65535/52191879805_4b17921792_b.jpg",
        caption: "Instagram Clone Practice (MERN)",
        desc: "This was my first project using MERN for the practice of MERN Stack.",
        githubLink: "https://github.com/abduldaim-ad/Instagram_Clone_Practice",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 20,
        imageSrc: "https://live.staticflickr.com/65535/52191409058_02b819560a_b.jpg",
        caption: "This Current Portfolio",
        desc: "This portfolio is being developed in React.js. You can check the source code using below GitHub Link.",
        githubLink: "https://github.com/abduldaim-ad/portfolio",
        status: "Deployed Link Here",
        deployedLink: "https://abduldaim-ad.github.io/portfolio/",
        pointerEvents: "",
    },
    {
        id: 21,
        imageSrc: "https://live.staticflickr.com/65535/52191394721_c271835001_b.jpg",
        caption: "E-Seller (MERN)",
        desc: "E-Seller was my semester project of web engineering. It has Sign In/Sign Up, Cart, Checkout, Pending Orders, etc.",
        githubLink: "https://github.com/abduldaim-ad/semester_project",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 22,
        imageSrc: "https://live.staticflickr.com/65535/52229492990_a4e1a30974_b.jpg",
        caption: "Landing Page",
        desc: "Based on the concepts of props and components reusability. This was good to practice the concepts of React.js.",
        githubLink: "https://github.com/abduldaim-ad/react-practice",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 23,
        imageSrc: "https://live.staticflickr.com/65535/52227968247_e08dca683a_b.jpg",
        caption: "AU Website 1",
        desc: "This project is made in HTML and CSS and has three web pages. It also has a google map displayed in the Contact Us page.",
        githubLink: "https://github.com/abduldaim-ad/au_website_html_css_lab_two",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 24,
        imageSrc: "https://live.staticflickr.com/65535/52229543530_254067da44_b.jpg",
        caption: "AU Website 2",
        desc: "This website has a background video placed at the header. It has also a beautiful table with hover effect.",
        githubLink: "https://github.com/abduldaim-ad/au_website_html_css",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 25,
        imageSrc: "https://live.staticflickr.com/65535/52228022532_fd910df6b5_b.jpg",
        caption: "Create User",
        desc: "Developed in HTML/CSS/JS and has functionality to add the information of user to the table.",
        githubLink: "https://github.com/abduldaim-ad/create-user",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 26,
        imageSrc: "https://live.staticflickr.com/65535/52245738169_8992c1826b_b.jpg",
        caption: "Counter App",
        desc: "A simple counter app with increment and decrement operations. The decrement stops when the number is zero.",
        githubLink: "https://github.com/abduldaim-ad/counter-app",
        status: "Deployed Link Here",
        deployedLink: "https://abduldaim-ad.github.io/counter-app/",
        pointerEvents: "",
    },
    {
        id: 27,
        imageSrc: "https://live.staticflickr.com/65535/52249606009_7d5c9cab78_b.jpg",
        caption: "Website Layout React",
        desc: "A simple layout of website developed in React.js with components of Header, Navbar, Aside, Main and Footer.",
        githubLink: "https://github.com/abduldaim-ad/website-layout-react",
        status: "Not Deployed",
        deployedLink: "#",
        pointerEvents: "none",
    },
    {
        id: 28,
        imageSrc: "https://live.staticflickr.com/65535/52267302449_b6438921e8_b.jpg",
        caption: "ToDo AD (MERN)",
        desc: "This is a todo app with MongoDB Atlas in which we can add items, remove items and also mark them as complete.",
        githubLink: "https://github.com/abduldaim-ad/todoad",
        status: "Deployed Link Here",
        deployedLink: "https://todoad.herokuapp.com/",
        pointerEvents: "",
    },
    {
        id: 29,
        imageSrc: "https://live.staticflickr.com/65535/52285959095_37a2036b09_b.jpg",
        caption: "BMI Calculator AD (React)",
        desc: "A simple bmi calculator app developed in react to calculate the body mass index by taking value of weight and height.",
        githubLink: "https://github.com/abduldaim-ad/bmi-ad",
        status: "Not Deployed",
        deployedLink: "https://abduldaim-ad.github.io/bmi-ad/",
        pointerEvents: "none",
    },
    {
        id: 30,
        imageSrc: "https://live.staticflickr.com/65535/53041050292_5e87587912_o.png",
        caption: "Task Manager",
        desc: "A web application using react+vite to practice the concepts of redux toolkit. Add, Edit, Update and Delete Task.",
        githubLink: "https://github.com/abduldaim-ad/task_management_rtk_vite_react",
        status: "Deployed Link Here",
        deployedLink: "https://abduldaim-ad.github.io/task_management_rtk_vite_react/",
        pointerEvents: "",
    },
    {
        id: 31,
        imageSrc: "https://live.staticflickr.com/65535/53057476670_f88a27b2c6_b.jpg",
        caption: "Random Score Game",
        desc: "Random Score generates random number from 1 to 10 and the player wins when score counts to a total of 50.",
        githubLink: "https://github.com/abduldaim-ad/randomscore",
        status: "Deployed Link Here",
        deployedLink: "https://abduldaim-ad.github.io/randomscore",
        pointerEvents: "",
    },
    
    {
        id: 32,
        imageSrc: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Tic_tac_toe.svg/1200px-Tic_tac_toe.svg.png",
        caption: "Tic Tac Toe",
        desc: "A famous tic tac toe game with interactive user interface. The game can be played with two players.",
        githubLink: "https://github.com/abduldaim-ad/tic-tac-toe",
        status: "Deployed Link Here",
        deployedLink: "https://abduldaim-ad.github.io/tic-tac-toe/",
        pointerEvents: "",
    },

];

export default ProjectsGallery.reverse();
